<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from "echarts";
import resize from "@/mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    options: {
      // type: Object,
      // required: true
    },
    index: {
      type: Number,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.options);
    },
    setOptions({pieData} = {}) {
      // let opt = Math.round(option * 100 * 100) / 100;
      let col = ["#5FD5EC", "#2276FC",'#FFCF5F'];
      this.chart.setOption({
        color: col,
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: "20",
          icon: "circle",
          itemHeight:7,
          textStyle:{
            color:"rgba(255, 255, 255, 0.8)",
          }
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: "80%",
            center: ["50%", "50%"],
            data: pieData,
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>
